import React from 'react';
import LocaleContainer from '../components/Containers/LocaleContainer';

const Locale = (props) => {
    return (
        <LocaleContainer
            from={props.from}
            buttonText="Export Data"
        />
    )
}

export default Locale;
